<template>
  <div class="container">
    <div class="content">
      <h1 class="title">fondr<span class="period">.</span></h1>
      <p class="subtitle">
        A collaborative space built for couples to save, organize, and share their
        favorite places, wishlist items, and meaningful milestones - all in one place.
      </p>
      <form class="form" action="https://api.web3forms.com/submit" method="POST" id="form">
            <input type="hidden" name="access_key" value="227d982e-39d8-4d91-aa0e-68ed2185f2b5" />
         
                 <div>
                <input class="field" type="email" name="email" id="email" placeholder="Email" required />
            </div>
       <button type="submit" class="cta">Join the Waitlist</button>
       </form>
   
    </div>
  </div>
</template>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 90vh; 

}

.field {
    padding: 0.75rem 1rem;
    border: 1px solid #66615C;
    font-size: 1rem;
    outline: none;
    font-size: 1rem;
}

.content {
   
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  max-width: 900px;
}

.title {
  font-size: clamp(4rem, 10vw, 10rem);
  font-weight: bold;
  margin: 0;
}

.period {
    color: #FF6B6B;
}

.subtitle {
  font-size: clamp(1rem, 10vw, 1.25rem);

}

.field,
.cta {
  width: 75%;
  margin-bottom: 0.5rem;          
  box-sizing: border-box;
}

.cta {
  background-color: #333333;
  border: none;
  font-size: 1rem;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  padding: 0.75rem 1rem;
}
</style>